export enum BlogSizeEnum {
  Large = 'Large',
  Medium = 'Medium',
  Small = 'Small',
}

export type BlogSizeType = keyof typeof BlogSizeEnum;
